import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  Box,
  Typography,
  IconButton,
  Collapse,
  Paper,
  Divider,
  Button,
  Grid,
} from "@mui/material";
import { ExpandMore, KeyboardArrowRight } from "@material-ui/icons";
import { ContentCopy } from "@mui/icons-material";
import {
  FilledButton,
  OutlinedButton,
  OutlinedErrorButton,
  OutlinedWarningButton,
  TrashIconRed,
} from "../../../../Styles";
import LinkSvg from "../../../../../assets/icons/link.svg";
import CopySvg from "../../../../../assets/icons/copy.svg";
import { ImgContainer } from "../../../../Orders/OrdersStyles";
import AutocompleteField from "../../../../Commons/AutocompleteField";
import {
  HeaderBox,
  MappingIndexTypography,
  ToggleButton,
  MappingRuleTypography,
  StyledCollapse,
  ContentBox,
  HeaderGrid,
  SectionLabelTypography,
  DuplicateButton,
  LabProductInfoContainer,
  ProductNameTypography,
  ProductTypeTypography,
  ProductPriceTypography,
  EquivalentBox,
  EmptyEquivalentBox,
  EquivalentLabelTypography,
  EquivalentNameTypography,
  EquivalentDescriptionTypography,
  EmptyEquivalentTypography,
  EquivalentPriceTypography,
  StyledDivider,
  LinkImageContainer,
  MappingRuleNote,
  HeaderGridTop,
  HeaderGridBottom,
  RemoveText,
  EquivalentProductLabel,
  FooterGridBottom,
} from "./MappingCardStyles";
import { fetchInventoryItems } from "../../../../../actions/inventoryActionsV2";
import { useDebounce } from "../../../../../commons/utils/useDebounce";

const MappingCard = ({
  mapping,
  isExpanded,
  toggleCollapseHandler,
  mappingDuplicateHandler,
  index,
  removeMappings,
  addLabProductMapping,
  resetMappingHandler,
  isMappingModified,
  isMappingAlreadyExists,
  oldMappingHasMappingId,
  updateMappingHandler,
  createMappingHandler,
  deleteMappingHandler,
  canShowDeleteMappingBtn,
  ...props
}) => {
  mapping.dentira_products = mapping.dentira_products.sort((a, b) => {
    return (b?.primary === true) - (a?.primary === true);
  });
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState("");

  const [labProductOptions, setLabProductOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleShowSearchBar = () => {
    setShowSearchBar(true);
  };

  const debouncedSearchLabProducts = useDebounce((txt) => {
    searchLabProducts(txt);
  }, 500);

  const searchTextChangeHandler = (txt) => {
    setLoading(true);
    debouncedSearchLabProducts(txt);
    setSelectedProduct(txt);
  };

  const addLabProductMappingHandler = (data) => {
    addLabProductMapping(mapping?.id, data);
    setSelectedProduct("")
  };

  const searchLabProducts = async (labProductSearchText) => {
    const { fetchInventoryItems } = props;

    let body = {
      page: 1,
      size: 10,
      search: labProductSearchText || "",
    };

    let products = [];

    if (labProductSearchText) {
      let response = await fetchInventoryItems(body);
      products = response?.products || [];
    }

    setLabProductOptions(
      products.map(({ supplier_product_id, name, description }) => ({
        value: supplier_product_id,
        label: name,
        description: supplier_product_id,
        // count: 15,
      }))
    );
    setLoading(false);
  };

  const removeMappingHandler = (
    productType = "",
    itemId = "",
    id,
    isPrimary
  ) => {
    removeMappings(productType, itemId, id, isPrimary);
  };

  const mappingRuleMsg = (mapping) => {
    let canShow = false,
      msg = "",
      hideLabAddProducts = false,
      hideDentiraAddProducts = false;

    if (
      !(
        mapping?.lab_products?.length === 0 ||
        mapping?.dentira_products?.length <= 1
      )
    ) {
      canShow = true;
      hideLabAddProducts = true;
      msg = `Multiple products selected in combination on Dentira's side. You can map them to only one of your products. If you are trying to map an add-on, please create a
									separate mapping where you map an add-on on lab's side to Dentira's side.`;
    }
    if (
      !(
        mapping?.dentira_products?.length === 0 ||
        mapping?.lab_products?.length <= 1
      )
    ) {
      canShow = true;
      hideDentiraAddProducts = true;
      msg = `	Multiple products selected in combination on Labs side already. You can map them to only one Dentira product. If you are trying to map an add-on, please create a
									separate mapping where you map an add-on on lab's side to Dentira's side.`;
    }

    return {
      canShow,
      msg,
      hideLabAddProducts,
      hideDentiraAddProducts,
    };
  };

  const { canShow, msg, hideLabAddProducts, hideDentiraAddProducts } = mappingRuleMsg(mapping);

  const getFilteredLabProductOptions = () => {
    return labProductOptions.filter((product) => {
      return !mapping?.lab_products.some(
        (mappedLabProduct) => mappedLabProduct.item_id === product.value
      );
    });
  };

  const isUpdateMapping = oldMappingHasMappingId(mapping?.id, true);

  const isMappingExists = isMappingAlreadyExists(mapping?.id);
  return (
    <div style={{backgroundColor: isExpanded ? '#0D4CBE1A':''}}>
      <HeaderBox>
        <MappingIndexTypography my={'1rem'}>
          Mapping {parseInt(mapping?.id?.split("_")?.[1] || 0) + 1}
        </MappingIndexTypography>
        <ToggleButton
          size="small"
          onClick={() => toggleCollapseHandler(mapping?.id)}
        >
          {isExpanded ? <ExpandMore /> : <KeyboardArrowRight />}
        </ToggleButton>
      </HeaderBox>
      {isExpanded && <MappingRuleTypography>{msg}</MappingRuleTypography>}
      <StyledCollapse style={{position: 'relative'}} in={isExpanded} unmountOnExit>
        <ContentBox style={{backgroundColor: '#fff'}}>
          <HeaderGrid container>
            <HeaderGridTop>
              <EquivalentLabelTypography>LAB PRODUCT</EquivalentLabelTypography>
              <div style={{display: 'flex', alignItems:'center', justifyContent: 'center'}}>
                <DuplicateButton
                  size="small"
                  onClick={() => mappingDuplicateHandler(mapping?.id)}
                >
                  <ImgContainer
                    style={{ width: 14, height: 14, mr: 0.5 }}
                    src={CopySvg}
                  />
                  DUPLICATE
                </DuplicateButton>
                {/* {canShowDeleteMappingBtn(mapping?.id) && <TrashIconRed onClick={() => deleteMappingHandler(mapping?.id)} />} */}
              </div>
            </HeaderGridTop>
            <MappingRuleNote>
              You can select one or multiple products that go together
            </MappingRuleNote>
          </HeaderGrid>
          {mapping?.lab_products.map((labProduct, idx) => {
            return (
              <LabProductInfoContainer>
                <Grid>
                  <ProductNameTypography>
                    {labProduct?.name || ""}
                  </ProductNameTypography>
                  <Grid style={{ display: "flex", alignItems: "center" }}>
                    <ProductTypeTypography>
                      {labProduct?.item_id || ""}
                    </ProductTypeTypography>
                    {idx !== 0 && (
                      <>
                        &nbsp;
                        <Typography>•</Typography>
                        <RemoveText
                          onClick={() =>
                            removeMappingHandler(
                              "lab_products",
                              labProduct?.item_id,
                              mapping?.id
                            )
                          }
                        >
                          Remove
                        </RemoveText>
                      </>
                    )}
                  </Grid>
                </Grid>
                {/* <Grid>
                  <ProductPriceTypography>
                    ${labProduct?.price || "56.99"}
                  </ProductPriceTypography>
                </Grid> */}
              </LabProductInfoContainer>
            );
          })}
          {!hideLabAddProducts &&
            (showSearchBar ? (
              <AutocompleteField
                text={selectedProduct}
                value={selectedProduct}
                onProductChange={addLabProductMappingHandler}
                options={getFilteredLabProductOptions()}
                placeholder="Search By Lab Product ID"
                onSearchTextChange={searchTextChangeHandler}
                loading={loading}
              />
            ) : (
              <OutlinedButton variant="outlined" onClick={handleShowSearchBar}>
                Add products that go with it
              </OutlinedButton>
            ))}
        </ContentBox>
        <Divider />

        <LinkImageContainer color="#000" src={LinkSvg} />

        {!!mapping?.dentira_products?.length ? (
          <>
            {mapping?.dentira_products?.map((dentiraProduct, idx) => {
              return (
                <EquivalentBox style={{backgroundColor: '#FDFCFA'}}>
                  {idx == 0 && (
                    <>
                      <EquivalentLabelTypography>
                        DENTIRA EQUIVALENT
                      </EquivalentLabelTypography>
                      {/* <MappingRuleNote>
                        Note: You can select either one primary product with
                        add-ons or a group of compatible add-ons.
                      </MappingRuleNote> */}
                    </>
                  )}
                  <ProductNameTypography>
                    {dentiraProduct?.name}
                  </ProductNameTypography>
                  <Grid style={{ display: "flex", alignItems: "center" }}>
                    <EquivalentProductLabel>
                      {dentiraProduct?.primary
                        ? "Primary Product"
                        : "Add-On Product"}
                    </EquivalentProductLabel>
                    &nbsp;
                    <Typography style={{ marginLeft: "3px" }}>•</Typography>
                    <EquivalentDescriptionTypography>
                      {dentiraProduct?.item_id}
                    </EquivalentDescriptionTypography>
                    &nbsp;
                    <Typography style={{ marginLeft: "3px" }}>•</Typography>
                    <RemoveText
                      onClick={() =>
                        removeMappingHandler(
                          "dentira_products",
                          dentiraProduct?.item_id,
                          mapping?.id,
                          dentiraProduct?.primary
                        )
                      }
                    >
                      Remove
                    </RemoveText>
                  </Grid>
                  {/* <EquivalentPriceTypography>
                    ${dentiraProduct?.price || "26.99"}
                  </EquivalentPriceTypography> */}
                </EquivalentBox>
              );
            })}
            <Box display={"flex"} gap={1} backgroundColor={"#FDFCFA"} padding={'1rem'} marginBottom={'1rem'}>
              <FilledButton
                variant="filled"
                disabled={!isMappingModified(mapping?.id) || isMappingExists}
                onClick={() =>
                  isUpdateMapping
                    ? updateMappingHandler(mapping?.id)
                    : createMappingHandler(mapping?.id)
                }
              >
                {isUpdateMapping ? "Update Mapping" : "Create Mapping"}
              </FilledButton>
              <OutlinedErrorButton
                onClick={() => resetMappingHandler(mapping?.id)}
                disabled={!isMappingModified(mapping?.id) || isMappingExists}
              >
                Reset
              </OutlinedErrorButton>
              {canShowDeleteMappingBtn(mapping?.id) && (
                <OutlinedErrorButton
                  onClick={() => deleteMappingHandler(mapping?.id)}
                >
                  Delete Mapping
                </OutlinedErrorButton>
              )}
            </Box>
            {isMappingExists && (
              <FooterGridBottom>
                <MappingRuleNote>
                  You cannot {isUpdateMapping ? "update" : "create"} mapping
                  with this combination, it already exists.
                </MappingRuleNote>
              </FooterGridBottom>
            )}
          </>
        ) : (
          <EmptyEquivalentBox>
            <EquivalentLabelTypography>
              DENTIRA EQUIVALENT
            </EquivalentLabelTypography>
            <EmptyEquivalentTypography>
              Nothing Selected
            </EmptyEquivalentTypography>
            {/* <OutlinedButton disabled>Create Mapping</OutlinedButton>
            <OutlinedButton disabled>Reset Mapping</OutlinedButton> */}
          </EmptyEquivalentBox>
        )}
      </StyledCollapse>
      <Divider />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatch = { fetchInventoryItems };

export default withRouter(connect(mapStateToProps, mapDispatch)(MappingCard));
